import React from 'react'
import './index.scss'
    
const NextButton = ({onClick = () => {}}) => {
    return <button onClick={onClick} className='next-button'>Next</button>
}

export default NextButton